export default {
    "it": {
        "rubinred": {
            "content": {
                "builder": {
                    "one_col": "Una colonna",
                    "two_col": "Due colonne",
                    "three_col": "Tre colonne",
                    "four_col": "Quattro colonne",
                    "thumb_list": "Lista thumb",
                    "pad_text": "Testo spaziato",
                    "divider": "Divisore",
                    "spacer": "Spaziatore",
                    "addBlockModal": {
                        "title": "Aggiungi elemento"
                    },
                    "cloneLanguageModal": {
                        "title": "Clona lingua",
                        "save": "Conferma",
                        "cancel": "Annulla"
                    },
                    "closeModal": {
                        "title": "Modifiche non salvate",
                        "message": "Sembra tu non abbia salvato tutte le tue modifiche. Vuoi salvarle?",
                        "back_editing": "Torna alle modifiche",
                        "discard_changes": "Cestina modifiche",
                        "save_changes": "Salva modifiche"
                    },
                    "editModal": {
                        "title": "Modifica sezione",
                        "tab_general": "Generali",
                        "tab_background": "Background",
                        "tab_design": "Design",
                        "tab_row": "Opzioni Riga",
                        "reset": "Resetta opzioni di default",
                        "cancel": "Annulla",
                        "save": "Ok",
                        "select_img": "Seleziona immagine",
                        "values_message": "Inserisci i valori seguiti dall'unità di misura. Es. 10px, 10%, etc.",
                        "row_message": "Queste opzioni sono disponibili solo nelle pagine <strong>full width</strong>. Puoi abilitare la modalità full width nelle impostazioni della pagina."
                    },
                    "errors": {
                        "error_fetch": "C'è stato un problema durante il caricamento del contenuto.",
                        "error_catch": "C'è stato un problema durante il caricamento delle sezioni.",
                        "error_save": "C'è stato un problema durante il salvataggio del contenuto.",
                        "error_save_catch": "C'è stato un problema durante il salvataggio delle sezioni."
                    },
                    "messages": {
                        "delete_item_confirm_title": "Elimina sezione",
                        "delete_item_confirm_text": "Sei sicuro di voler rimuovere la sezione e tutti i suoi contenuti?",
                        "delete": "Elimina",
                        "cancel": "Annulla",
                        "item_duplicated": "La sezione è stata duplicata con sucesso!"
                    },
                    "edit": {
                        "yes": "Si",
                        "no": "No",
                        "background_color": "Background Color",
                        "background_image": "Background Image",
                        "background_position": "Background Position (x,y)",
                        "background_size": "Background Size",
                        "background_repeat": "Background Repeat",
                        "background_attachment": "Background Attachment",
                        "columns_valign": "Allineamento verticale colonne",
                        "columns_reverse": "Inverti colonne",
                        "columns_collapse": "Collassa colonne",
                        "hide_small": "Nascondi per mobile",
                        "center_small": "Testo centrato per mobile",
                        "css_box": "CSS Box",
                        "margin": "Margin",
                        "padding": "Padding",
                        "border": "Border",
                        "content": "Content",
                        "border_color": "Border Color",
                        "border_style": "Border Style",
                        "border_radius": "Border Radius",
                        "row_background": "Row Background",
                        "row_wrap": "Wrap row"
                    }
                }
            },
            "forms": {
                "forms": {
                    "message": {
                        "submission": {
                            "error": "Controlla la presenza di errori nel form."
                        }
                    }
                },
                "privacies": {
                    "common": {
                        "privacy_labels": {
                            "consent": "Presta il consenso",
                            "do_not_consent": "Nega il consenso"
                        }
                    }
                }
            }
        },
        "frontend-message": {
            "delete_record": "Stai per cancellare questo record, vuoi continuare?",
            "not_logged_in": "Non sei loggato.",
            "loading": "Caricamento",
            "check_form": "Errore: controlla il modulo.",
            "something_wrong": "Ops, qualcosa è andato storto (:code). Se il problema persiste contattaci."
        },
        "frontend-action": {
            "add": "Aggiungi",
            "create": "Crea",
            "remove": "Rimuovi",
            "cancel": "Annulla",
            "delete": "Elimina",
            "edit": "Modifica",
            "submit": "Invia",
            "save": "Salva",
            "copy": "Copia",
            "paste": "Incolla",
            "update": "Aggiorna",
            "enable": "Abilita",
            "disable": "Disabilita",
            "install": "Installa",
            "uninstall": "Disinstalla",
            "open": "Apri",
            "close": "Chiudi",
            "collapse": "Apri/Chiudi",
            "upload": "Carica",
            "export": "Esporta",
            "preview": "Anteprima",
            "view": "Mostra",
            "play": "Play",
            "pause": "Pausa",
            "stop": "Stop",
            "select": "Seleziona",
            "select_language": "Seleziona lingua",
            "select_languages": "Seleziona lingue",
            "select_all": "Seleziona tutto",
            "select_element": "Seleziona un elemento...",
            "select_elements": "Seleziona uno o più elementi...",
            "drop_here": "Rilascia qui",
            "load_more": "Carica ancora",
            "send": "Invia",
            "share": "Condividi",
            "download": "Scarica",
            "back": "Indietro",
            "logout": "Logout",
            "bulk": {
                "delete": "Elimina Selezionati",
                "enable": "Abilita Selezionati",
                "disable": "Disabilita Selezionati"
            }
        },
        "frontend-common": {
            "error": "Errore",
            "success": "Successo",
            "info": "Info",
            "warning": "Attenzione",
            "danger": "Pericolo",
            "yes": "Sì",
            "no": "No",
            "all": "Tutto",
            "enabled": "Abilita",
            "disabled": "Disabilita",
            "installed": "Installato",
            "uninstalled": "Disinstallato",
            "actions": "Azioni",
            "bulk_actions": "Azioni di gruppo",
            "allow": "Permetti",
            "deny": "Nega",
            "inherit": "Eredita",
            "read_only": "Leggi solo",
            "reset": "Reset",
            "refresh": "Ricarica",
            "profile": "Profilo",
            "no_results": "Nessun risultato",
            "showing": "Mostra",
            "to": "a",
            "in": "in",
            "of": "di",
            "entries": "inserimenti",
            "loading": "Caricamento",
            "search": "Cerca",
            "filters": "Filtri",
            "order": "Ordina",
            "remove_filter": "Rimuovi filtro",
            "show_all": "mostra tutto",
            "show_enabled": "Mostra abilitati",
            "show_disabled": "mostra disabilitati",
            "show_more": "Mostra di più",
            "show_less": "Mostra meno",
            "all_enabled": "Tutti gli abilitati",
            "all_disabled": "Tutti i disabilitati",
            "per_page": "Per pagina",
            "language": "Lingua",
            "words_count": "{0} Nessuna parola|{1} Una parola|[2,Inf] :count parole",
            "preset": "Preset",
            "presets": "Presets",
            "privacy_policy": "Privacy policy",
            "company_info": "Company info",
            "safe_purchase": "Acquisto sicuro"
        }
    }
};


// WEBPACK FOOTER //
// ./public/themes/frontend/museo/assets/js/translations.js